import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth"; // ✅ import added
import { getFirestore } from "firebase/firestore";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyC1WSKy4qDGDEV2hlhyjTDi9LKwfuZbh5Q",
  authDomain: "karera-df27b.firebaseapp.com",
  projectId: "karera-df27b",
  storageBucket: "karera-df27b.firebasestorage.app",
  messagingSenderId: "358965189734",
  appId: "1:358965189734:web:ab3e3d60e27033c81ee1a7"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);